module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-detail-bill"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-wrapper"
  }, [_c('h4', {
    staticClass: "detail-bill-address"
  }, [_vm._v("和合谷 > 北京配送中心\n\t\t"), _c('router-link', {
    staticClass: "detail-bill-edit grey-font",
    attrs: {
      "to": "/detail-bill-edit"
    }
  }, [_vm._v("编辑")])], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-footer"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-agreen"
  }, [_c('router-link', {
    attrs: {
      "to": "/all-order-bill"
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-return"
  }, [_c('router-link', {
    attrs: {
      "to": "/all-order-bill"
    }
  }, [_vm._v("发货")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter"
  }, [_c('input', {
    staticClass: "ui-search-input",
    attrs: {
      "type": "text",
      "placeholder": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "detail-bill-status"
  }, [_vm._v("订单号：CD20160721001001"), _c('span', {
    staticClass: "aqua-font"
  }, [_vm._v("待发货")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "detail-bill-list"
  }, [_c('li', [_vm._v("大米(袋)\n\t\t\t\t"), _c('ul', {
    staticClass: "detail-bill-sonlist"
  }, [_c('li', [_vm._v("订货数量：1200")]), _vm._v(" "), _c('li', [_vm._v("发货数量：1200")]), _vm._v(" "), _c('li', [_vm._v("税率：6%")]), _vm._v(" "), _c('li', [_vm._v("含税单价：￥1200")]), _vm._v(" "), _c('li'), _vm._v(" "), _c('li', [_vm._v("加税合计：￥1200")])])]), _vm._v(" "), _c('li', [_vm._v("六寸卷边黄金蝴蝶虾皮披萨(个)\n\t\t\t\t"), _c('ul', {
    staticClass: "detail-bill-sonlist"
  }, [_c('li', [_vm._v("订货数量：1200")]), _vm._v(" "), _c('li', [_vm._v("发货数量：1200")]), _vm._v(" "), _c('li', [_vm._v("税率：6%")]), _vm._v(" "), _c('li', [_vm._v("含税单价：￥1200")]), _vm._v(" "), _c('li'), _vm._v(" "), _c('li', [_vm._v("加税合计：￥1200")])])]), _vm._v(" "), _c('li', [_vm._v("黑椒牛柳(盒)\n\t\t\t\t"), _c('ul', {
    staticClass: "detail-bill-sonlist"
  }, [_c('li', [_vm._v("订货数量：1200")]), _vm._v(" "), _c('li', [_vm._v("发货数量：1200")]), _vm._v(" "), _c('li', [_vm._v("税率：6%")]), _vm._v(" "), _c('li', [_vm._v("含税单价：￥1200")]), _vm._v(" "), _c('li'), _vm._v(" "), _c('li', [_vm._v("加税合计：￥1200")])])]), _vm._v(" "), _c('li', [_vm._v("黑椒牛柳(盒)\n\t\t\t\t"), _c('ul', {
    staticClass: "detail-bill-sonlist"
  }, [_c('li', [_vm._v("订货数量：1200")]), _vm._v(" "), _c('li', [_vm._v("发货数量：1200")]), _vm._v(" "), _c('li', [_vm._v("税率：6%")]), _vm._v(" "), _c('li', [_vm._v("含税单价：￥1200")]), _vm._v(" "), _c('li'), _vm._v(" "), _c('li', [_vm._v("加税合计：￥1200")])])]), _vm._v(" "), _c('li', [_vm._v("黑椒牛柳(盒)\n\t\t\t\t"), _c('ul', {
    staticClass: "detail-bill-sonlist"
  }, [_c('li', [_vm._v("订货数量：1200")]), _vm._v(" "), _c('li', [_vm._v("发货数量：1200")]), _vm._v(" "), _c('li', [_vm._v("税率：6%")]), _vm._v(" "), _c('li', [_vm._v("含税单价：￥1200")]), _vm._v(" "), _c('li'), _vm._v(" "), _c('li', [_vm._v("加税合计：￥1200")])])]), _vm._v(" "), _c('li', [_vm._v("黑椒牛柳(盒)\n\t\t\t\t"), _c('ul', {
    staticClass: "detail-bill-sonlist"
  }, [_c('li', [_vm._v("订货数量：1200")]), _vm._v(" "), _c('li', [_vm._v("发货数量：1200")]), _vm._v(" "), _c('li', [_vm._v("税率：6%")]), _vm._v(" "), _c('li', [_vm._v("含税单价：￥1200")]), _vm._v(" "), _c('li'), _vm._v(" "), _c('li', [_vm._v("加税合计：￥1200")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-bill-info"
  }, [_c('p', [_vm._v("配送至：前门店")]), _vm._v(" "), _c('p', [_vm._v("总计：￥1500")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7b2265da!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/DetailBillFirst.vue
// module id = 593
// module chunks = 1